import { render, staticRenderFns } from "./ReviewPressForms.vue?vue&type=template&id=7ce4d173"
import script from "./ReviewPressForms.vue?vue&type=script&lang=js"
export * from "./ReviewPressForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports